import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import type { User } from '@/lib/types';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export function useGetAllAdmin() {
	return useQuery<User[]>({
		queryKey: ['get-all-admin', schoolId],
		queryFn: async () => {
			const { data, error } = await supabase
				.from('users')
				.select('user_email, user_first, user_last')
				.eq('school_id', schoolId)
				.eq('user_role', 'admin');

			if (error) throw error;

			return data as unknown as User[];
		},
		staleTime: Infinity,
	});
}
